
import { oz } from '@weft/utils';
import { created } from '../../utils/created';
import { NewRevisionedLineItemSchema } from './new-revision-line-item-schema';

export const RevisionedLineItemSchema = created(NewRevisionedLineItemSchema).extend({
  price: oz.number(),
}).openapi('RevisionedLineItem');

export type RevisionedLineItem = oz.infer<typeof RevisionedLineItemSchema>;